export const formatCurrency = (amount) => {
    if (!amount && amount !== 0)
        return '$0.00';
    if (typeof amount === 'string' && amount.startsWith('$')) {
        const withoutDollar = amount.substring(1);
        const numCheck = parseFloat(withoutDollar.replace(/,/g, ''));
        if (!isNaN(numCheck)) {
            return new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
            }).format(numCheck);
        }
        return amount;
    }
    const cleanAmount = typeof amount === 'string' ? amount.replace(/,/g, '').replace(/[^0-9.-]/g, '') : amount;
    const numericAmount = typeof cleanAmount === 'string' ? parseFloat(cleanAmount) : cleanAmount;
    if (isNaN(numericAmount))
        return '$0.00';
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    }).format(numericAmount);
};
export const formatPrice = (price) => {
    return formatCurrency(price);
};
